import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import Navbar from "../components/Navbar";
import { CheckCircle2, XCircle, Clock } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("polling"); // polling | paid | expired | error
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    const poll = async (n) => {
      if (cancelled) return;
      if (n >= 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        setAttempts(n+1);
        if (r.data.payment_status === "paid") {
          await refresh();
          setStatus("paid");
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        setTimeout(() => poll(n+1), 2000);
      } catch {
        setTimeout(() => poll(n+1), 2000);
      }
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-20 text-center">
        {status === "polling" && (
          <>
            <Clock className="mx-auto text-[#C25934]" size={40}/>
            <h1 className="font-serif-display text-3xl mt-4 text-[#1E3F33]">Verifica pagamento…</h1>
            <p className="mt-2 text-[#6B6B6B]">Tentativo {attempts+1}/8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto text-[#2D5A47]" size={48}/>
            <h1 data-testid="payment-success" className="font-serif-display text-4xl mt-4 text-[#1E3F33]">Pagamento confermato</h1>
            <p className="mt-3 text-[#6B6B6B]">Il tuo piano è ora attivo. Puoi iniziare subito a monitorare la tua IVA.</p>
            <Link to="/dashboard" className="btn-lift inline-block mt-8 px-6 py-3 bg-[#1E3F33] text-white rounded-md">Vai al cruscotto</Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="mx-auto text-[#A83C22]" size={48}/>
            <h1 className="font-serif-display text-3xl mt-4 text-[#1E3F33]">Impossibile confermare</h1>
            <p className="mt-3 text-[#6B6B6B]">Se il pagamento è andato a buon fine, riceverai una email di conferma. In caso di problemi contattaci.</p>
            <Link to="/piani" className="btn-lift inline-block mt-6 px-6 py-3 border border-[#1E3F33] rounded-md">Torna ai piani</Link>
          </>
        )}
      </div>
    </div>
  );
}
